import { configureStore } from "@reduxjs/toolkit";
import messageReducer from "../slices/messageSlice.js";
import providerRegistryReducer from "../slices/providerRegistrySlice.js";
import patientReducer from "../slices/patientSlice.js";
import encounterReducer from "../slices/encounterSlice.js";
import configReducer from "../slices/configSlice.js"; // 🆕 new import

export const createStore = () =>
  configureStore({
    reducer: {
      messages: messageReducer,
      providers: providerRegistryReducer,
      patients: patientReducer,
      encounters: encounterReducer,
      config: configReducer, // 🆕 added config slice
    },
  });

export default createStore;